import classNames from 'classnames'
import { forwardRef, type PropsWithChildren, type ReactElement } from 'react'
import { Text } from '../text'
import Input, { type InputProps, InputType } from './input'
import Ripple from '../../../components/Ripple'
import { generateKey } from '../../../utils/helpers'

// @ts-ignore
export const enum CheckboxType {
  Button,
  StringValue,
}

export type CheckboxProps = InputProps & {
  classic?: boolean
  noInk?: boolean
  checkbox?: boolean
  icon?: string
  simple?: boolean
  checkboxType?: CheckboxType
  checkboxProps?: any
  stringCheckedValue?: string
}

export const CheckboxInner: React.FC<CheckboxProps> = forwardRef<ReactElement, PropsWithChildren<CheckboxProps>>(
  (
    {
      //children,
      classic,
      noInk,
      //checkbox,
      icon,
      minimal,
      simple,
      label,
      className,
      value,
      isDirty,
      isTouched,
      invalid,
      //error,
      checkboxType,
      checkboxProps,
      stringCheckedValue,
      onChange,
      onCustomChange,
      ...inputProps
    },
    ref,
  ) => {
    let type: any
    const isChecked = checkboxType === CheckboxType.StringValue ? value === stringCheckedValue : (!!value as any)
    const input = (
      <input
        type="checkbox"
        ref={ref as any}
        checked={isChecked}
        onChange={(e: any) => {
          onChange?.(e)
          onCustomChange?.(e.target.name as string, e.target.checked)
        }}
        {...inputProps}
      />
    )

    const isButton = checkboxType === CheckboxType.Button

    if (minimal || simple || classic) {
      if (classic) {
        type = { classic: '' }
      } else {
        type = { checkbox: '' }
        if (minimal) {
          type.minimal = ''
        }
        if (simple) {
          type.simple = ''
        }
      }
    } else if (!isButton) {
      type = { classic: '' }
    }

    const content = (
      <label
        {...type}
        {...checkboxProps}
        className={classNames(className, {
          error: invalid,
          touched: isTouched,
          dirty: isDirty,
        })}
      >
        {input}

        {isButton ? (
          <wrap>
            {icon && <icon>{icon}</icon>}
            {label && <Text>{label}</Text>}
          </wrap>
        ) : (
          <>
            <box>
              <check></check>

              {!minimal && !simple && !noInk && (
                <Ripple key={generateKey()}>
                  <ink></ink>
                </Ripple>
              )}
            </box>
            {label && <Text>{label}</Text>}
          </>
        )}
      </label>
    )

    return content
  },
)

const Checkbox: React.FC<CheckboxProps> = forwardRef<ReactElement, PropsWithChildren<CheckboxProps>>((props, ref) => {
  return <Input ref={ref} {...props} type={InputType.Checkbox} />
})

export default Checkbox
